/* eslint-disable */
import { AlertAdapter, RegularButton } from 'pg-ui-library';
import { ISupportDesk, ISupportData } from 'src/interfaces';
import { useParams } from 'react-router-dom';
import React from 'react';
import { IReply } from 'src/interfaces';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useQuery } from '@tanstack/react-query';
import SupportDeskService from 'src/services/support-desk.service';
import { useReopenticket } from '../mutations/add-update-reply-support-ticket';

import {
  ReopenTicketForm,
  ReopenTicketBody,
  ReopenTicketHeader,
  ReplyTextarea,
  ReopenFooter,
  ReopenQues,
  ReopenLabel,
} from './styles';

export const TicketReopenModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  supportTicket?: ISupportDesk;
  // eslint-disable-next-line react/prop-types
}> = ({ isOpen, setIsOpen, supportTicket }) => {
  const { t } = useTranslation();
  const ticketIdShown = supportTicket?.supportNumber;
  const { ticketId } = useParams<{ ticketId: string }>();
  const companyId = '';
  const { isFetching, data, refetch } = useQuery(['support-desk-reply'], async () => {
    const result = await SupportDeskService.getSupportTicketsReply({
      companyId,
      ticketId,
    });
    return result;
  });

  const reopenTicket = useReopenticket();

  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const validationSchema = yup.object().shape({
    description: yup.string().required().min(1).max(255),
  });

  const formik = useFormik({
    initialValues: {
      description: '',
    },
    validationSchema,
    onSubmit: async (values: IReply) => {
      if (!ticketId) {
        return;
      }
      await reopenTicket.mutateAsync({ ticketId, ticket: values });
      AlertAdapter('Ticket is reopened!', 'success');
      refetch();
      setIsOpen(!isOpen);
    },
  });

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '700px',
          height: '420px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 40px 0 40px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ReopenTicketForm onSubmit={formik.handleSubmit}>
        <ReopenTicketHeader>
          <div>
            <h3>
              {t('global.form.reopen')} #{ticketIdShown}
            </h3>
          </div>
          <div style={{ marginTop: '30px' }}>
            <CloseIcon src={closeSvg} onClick={() => handleModal()} />
          </div>
        </ReopenTicketHeader>
        <ReopenTicketBody>
          <ReopenQues>
            <p>Are you sure you want to REOPEN this ticket?</p>
          </ReopenQues>
          <ReopenLabel>Reason for status change (Optional)</ReopenLabel>
          <ReplyTextarea
            placeholder="Enter here..."
            value={formik.values.description}
            onChange={event => formik.setFieldValue('description', event.target.value)}
          />
          <ReopenFooter>
            <RegularButton
              disabled={formik.isSubmitting || !formik.isValid}
              type="submit"
              style={{ color: '#4948AC', backgroundColor: '#fff' }}
            >
              {t('global.form.cancel')}
            </RegularButton>
            <RegularButton disabled={formik.isSubmitting || !formik.isValid} type="submit">
              {t('global.form.reopenbtn')}
            </RegularButton>
          </ReopenFooter>
        </ReopenTicketBody>
      </ReopenTicketForm>
    </ReactModal>
  );
};
